import { render, staticRenderFns } from "./WBzh.vue?vue&type=template&id=0214276f&scoped=true"
import script from "./WBzh.vue?vue&type=script&lang=js"
export * from "./WBzh.vue?vue&type=script&lang=js"
import style0 from "./WBzh.vue?vue&type=style&index=0&id=0214276f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0214276f",
  null
  
)

export default component.exports